<template>
  <div id="accordion" class="w-100">
    <div v-for="(item,user_id) in campaigns">
        <ItemMonitor
          :stats="campaigns"
          :type="'campaigns'"
          :ref="user_id"
          :user_id="user_id"
          :target_id="orderId"
        ></ItemMonitor>
    </div>
  </div>
</template>

<script>

import Vue from "vue";
import { targetsService, usersService } from "@/_services";
import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";


export default {
  data () {
    return {
      campaigns:[],
    }
  },
  
  props: {
    orderId:String
  },  

  components: { ItemMonitor },


  created() {
      targetsService.getCampaignForOrder(this.orderId).then((responseCampaign) => {
          this.campaigns = responseCampaign
        
      })
  },
  methods:{
    
  }
  
};
</script>